'use strict';

$(document.body).on('hover focus click', '.js-external-link-initialized', function () {
  var $link = $(this);
  $link.attr('href', $link.attr('data-href'));
  $link.removeAttr('data-href');
  $link.removeClass('js-external-link-initialized');
});

$.fn.extend({
  externalLinks: function (options) {
    return this.each(function () {
      $(this).find('.js-external-link')
        .removeClass('js-external-link')
        .addClass('js-external-link-initialized')
        .attr('href', '#');
    });
  }
});
